import { webApi } from '@mi-front/api-clients';

const COMPLETED = 'COMPLETED';

const DISPLAY_STATUSES = [COMPLETED, 'SCHEDULED', 'FAILED'] as const;

const PUBLISHED_PLATFORM_DISPLAY_STATUSES = [COMPLETED, 'FAILED'] as const;

export type DisplayPlatformItem = { id: string; platform: string; status: string };

/**
 * Builds platform status rows for social pills from list payloads: prefers
 * `publishedPlatforms` when present, otherwise filters `uploadStatuses` to displayable states.
 */
export function getDisplayPlatformItems(props: {
  uploadStatuses: webApi.UploadStatusItemDto[];
  publishedPlatforms?: ReadonlyArray<{
    platform: string;
    status: string;
    uploadId: string;
  }>;
}): DisplayPlatformItem[] {
  const { uploadStatuses, publishedPlatforms } = props;
  if (publishedPlatforms?.length) {
    return publishedPlatforms
      .filter((p) =>
        PUBLISHED_PLATFORM_DISPLAY_STATUSES.includes(
          p.status as (typeof PUBLISHED_PLATFORM_DISPLAY_STATUSES)[number],
        ),
      )
      .map((p) => ({ id: p.uploadId, platform: p.platform, status: p.status }));
  }
  return uploadStatuses
    .filter((u) => DISPLAY_STATUSES.includes(u.status as (typeof DISPLAY_STATUSES)[number]))
    .map((u) => ({ id: u.id, platform: u.platform, status: u.status }));
}
